import React from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";

import { useNotification } from "@hooks/useNotification";
import { useReduxSelector } from "@hooks/useReduxSelector";
//import { ThemeProvider, FormControlLabel, Checkbox } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

import "@css/components/dropdownSelect.css";

import DefaultDatePicker from "@components/arhDatePicker/DefaultDatePicker";
import LocationSearchInput from "@components/input/locationSearchInput";
import { ListboxEmploye } from "@components/tailwindComponents";
import ListboxGroupe from "@components/tailwindComponents/ListboxGroupe/index";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";
import { CheckboxSimple, Input } from "@components/tailwindComponents/index";

import {
  REGEX_EMAIL,
  REGEX_PHONE,
  REGEX_POST_NUMBER
} from "@helpers/_constants";
import { truncateTextPlaceholder } from "@helpers/_functions";
import useGenderType from "@pages/shared/employeFormNew/PersonnalInformations/hooksGenderType";

const useStylesBootstrap = makeStyles(() => ({
  arrow: {
    color: "#3F3F51"
  },
  tooltip: {
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "23px 17px"
  }
}));
function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();
  return (
    <Tooltip
      arrow
      classes={classes}
      {...props}
    />
  );
}

function ItemEmployeList({
  employe,
  selectedColumn,
  selectItem,
  handlePersonnalInformation,
  handleEmails,
  handleAdress,
  handleEmploi,
  handleEmployeNumberChange,
  handleGroups,
  postList,
  emplacementList,
  permissionList,
  userList,
  handleEmploiInfos,
  handlePhone,
  isChecked,
  handleFirstEmergencyContact,
  handlePersonalEmail,
  handleSecondEmergencyContact,
  handleChangeBankingInformation
}) {
  const {
    _id: employeId,
    isMailAlreadyInDB,
    isNumberAlreadyInDB,
    hasEmailDuplication,
    hasNumberDuplication,
    isToFill,
    personnalInformation,
    emploi,
    adress,
    emails,
    firstEmergencyContact,
    secondEmergencyContact,
    BankingAndInsuranceInformation
  } = employe;
  const { t } = useTranslation("pages.employés.importation");
  const { showError } = useNotification();
  const groupes = useReduxSelector(({ commonData }) => commonData.groupes);
  const { allGenderTypes: translaGenre } = useGenderType();

  const changePersonnalInformation = (e) => {
    handlePersonnalInformation(e, employeId);
  };

  const changeBankingInfo = (e) => {
    handleChangeBankingInformation(e, employeId);
  };

  const changeFirstEmergencyContact = (e) => {
    handleFirstEmergencyContact(e, employeId);
  };

  const changeSecondEmergencyContact = (e) => {
    handleSecondEmergencyContact(e, employeId);
  };

  const changePhone = (e) => {
    const personalPhone = e?.target?.value;
    handlePhone(personalPhone, employeId);
  };

  const changeEmails = async (e) => {
    if (e.target?.name === "personalEmail") {
      const personalEmail = e?.target?.value;
      handlePersonalEmail(personalEmail, employeId);
    } else {
      handleEmails(e, employeId);
    }
  };

  const changeAdress = (e) => {
    handleAdress(e, employeId);
  };

  const changeEmploi = (e, name) => {
    handleEmploi(e, employeId, name);
  };

  const changeEmploiInfos = (e, label) => {
    handleEmploiInfos(e, label, employeId);
  };

  let hiringDate =
    typeof emploi.hiringDate === "object"
      ? emploi.hiringDate
      : moment(emploi.hiringDate).toDate();

  let dateOfBirth =
    typeof personnalInformation.dateOfBirth === "object"
      ? personnalInformation.dateOfBirth
      : moment(personnalInformation.dateOfBirth).toDate();

  const handleSelectLocation = (address, additionalInfo) => {
    if (additionalInfo?.city) {
      handleAdress(
        {
          address,
          additionalInfo: {
            ...additionalInfo,
            zipCode: additionalInfo.postalCode
          }
        },
        employeId
      );
    } else {
      handleChangeLocation();
      showError("Veuillez préciser le nom de la ville");
    }
  };

  const handleSelectGroups = (groupes) => {
    handleGroups(groupes, "groupes", employeId);
  };

  const handleChangeLocation = () => {
    if (adress.firstAdress) {
      handleAdress(
        {
          address: "",
          additionalInfo: {
            zipCode: "",
            province: "",
            city: "",
            country: "",
            countryCode: ""
          }
        },
        employeId
      );
    }
  };
  return (
    <>
      <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
        <div className="status-wrapper flex-direction-column  flex-justify-center flex-align-center status_import_employer arh-flex">
          {!hasEmailDuplication &&
            !isMailAlreadyInDB &&
            !isNumberAlreadyInDB &&
            !isToFill &&
            !hasNumberDuplication && (
              <BootstrapTooltip
                title={t("Prêt à être importé")}
                placement="top-end"
              >
                <span className="dots_statut status_green"></span>
              </BootstrapTooltip>
            )}
          {(hasEmailDuplication || hasNumberDuplication) && (
            <BootstrapTooltip
              title={t("Duplication")}
              placement="top-end"
            >
              <span className="dots_statut status_yellow"></span>
            </BootstrapTooltip>
          )}
          {(isMailAlreadyInDB || isNumberAlreadyInDB) && (
            <BootstrapTooltip
              title={t("Existe déjà dans la BD")}
              placement="top-end"
            >
              <span className="dots_statut status_red"></span>
            </BootstrapTooltip>
          )}
          {isToFill && (
            <BootstrapTooltip
              title={t("À compléter")}
              placement="top-end"
            >
              <span className="dots_statut status_error"></span>
            </BootstrapTooltip>
          )}
        </div>
      </td>
      <td className="arh-p-2 arh-font-poppins arh-text-xs arh-font-semibold   arh-text-darkColor">
        <CheckboxSimple
          checked={isChecked}
          onChange={() => {
            selectItem(employe);
          }}
        />
      </td>

      {selectedColumn.find((clm) => clm.name === "Prénom légal") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="legalFirstName"
              placeholder={`${t("Prénom légal")} *`}
              onBlur={changePersonnalInformation}
              defaultValue={personnalInformation?.legalFirstName || ""}
              invalid={!personnalInformation?.legalFirstName}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Nom légal") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="legalName"
              placeholder={`${t("Nom légal")} *`}
              onBlur={changePersonnalInformation}
              defaultValue={personnalInformation?.legalName || ""}
              invalid={!personnalInformation?.legalName}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Courriel de correspondance"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="personalEmail"
              placeholder={`${truncateTextPlaceholder(t("Courriel de correspondance"), 22)} *`}
              onBlur={changeEmails}
              defaultValue={emails?.personalEmail || ""}
              invalid={
                !emails?.personalEmail ||
                !REGEX_EMAIL.test(emails?.personalEmail)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Genre légal") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <ListboxSimple
              optionList={translaGenre}
              placeholder={`${t("Genre légal")} *`}
              name="legalGender"
              setSelectedValue={(selected) => {
                changePersonnalInformation({
                  target: {
                    name: "legalGender",
                    value: selected._id
                  }
                });
              }}
              selectedValue={translaGenre?.find(
                (_gender) => _gender._id === personnalInformation?.legalGender
              )}
              invalid={!Boolean(personnalInformation?.legalGender)}
              noRadio
              withTooltip
              showReset
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Poste") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <ListboxSimple
              optionList={postList}
              placeholder={`${t("Poste")} *`}
              name="poste"
              optionTextAttribut="title"
              setSelectedValue={(_post) =>
                changeEmploiInfos(_post._id, "poste")
              }
              selectedValue={postList?.find(
                (_post) => _post._id === emploi?.poste
              )}
              invalid={!Boolean(emploi?.poste)}
              noRadio
              withTooltip
              showReset
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Emplacement") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <ListboxSimple
              placeholder={t("Emplacement*")}
              name="emplacement"
              optionList={emplacementList || []}
              selectedValue={emploi?.emplacement || []}
              setSelectedValue={(emplacement) => {
                changeEmploiInfos(emplacement, "emplacement");
              }}
              showReset
              multiple
              invalid={!Boolean(emploi.emplacement)}
              zIndex3
              withTooltip
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Permission") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <ListboxSimple
              optionList={permissionList}
              placeholder={`${t("Permission")} *`}
              name="authorization"
              optionTextAttribut="role"
              setSelectedValue={(_role) =>
                changeEmploiInfos(_role._id, "authorization")
              }
              selectedValue={permissionList?.find(
                (_role) => _role._id === emploi?.authorization
              )}
              invalid={!Boolean(emploi.authorization)}
              noRadio
              withTooltip
              showReset
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Supérieur hierarchique") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <ListboxEmploye
              optionList={userList}
              placeholder={`${t("Supérieur hiérarchique")} *`}
              name="valueHierarchicalSelected"
              selectedValue={userList?.find(
                (_employee) => _employee.id === emploi.valueHierarchicalSelected
              )}
              setSelectedValue={(employee) =>
                changeEmploiInfos(employee.id, "valueHierarchicalSelected")
              }
              invalid={!Boolean(emploi.valueHierarchicalSelected)}
              withSearch
              showReset
              noRadio
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Groupe") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <ListboxGroupe
              placeholder={t("Groupe")}
              name="Groupes"
              optionList={groupes || []}
              selectedValue={employe.groupes || []}
              setSelectedValue={handleSelectGroups}
              labelActive={true}
              classLabel="arh-flex"
              zIndex3
              viewforDesktop={true}
              TooltipLabel={true}
              showReset
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Date d'embauche") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="calendar_with_btn employerThemeDatePicker arh-flex arh-min-w-[200px] arh-flex-col ">
            <DefaultDatePicker
              className="focus_green no_border"
              name="hiringDate"
              placeholder={t("Date d'embauche")}
              dateValue={hiringDate || null}
              setDateValue={(date) => changeEmploi(date || null, "hiringDate")}
              isInForeground
              right0
              customClass="arh-bottom-10"
              marginTop={150}
              zIndex3
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Date d'anniversaire") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="calendar_with_btn employerThemeDatePicker arh-flex arh-min-w-[200px] arh-flex-col ">
            <DefaultDatePicker
              className="focus_green no_border"
              name="dateOfBirth"
              placeholder={t("Date d'anniversaire")}
              dateValue={dateOfBirth || null}
              setDateValue={(date) => changeEmploi(date || null, "dateOfBirth")}
              isInForeground
              right0
              customClass="arh-bottom-10"
              marginTop={150}
              zIndex3
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Téléphone personnel") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="personalPhone"
              placeholder={t("Téléphone personnel")}
              onBlur={changePhone}
              onChange={changePhone}
              value={emails?.personalPhone || ""}
              invalid={
                emails?.personalPhone &&
                !REGEX_PHONE.test(emails?.personalPhone)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "N de poste (personnel)") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="personalPhonePostNumber"
              placeholder={t("N de poste")}
              onBlur={changeEmails}
              defaultValue={emails?.personalPhonePostNumber || ""}
              invalid={
                emails?.personalPhonePostNumber &&
                !REGEX_POST_NUMBER.test(emails?.personalPhonePostNumber)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Adresse") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <LocationSearchInput
            className="arh-min-w-[200px]"
            // label={`${t("Adresse")} *`}
            classInput={"input_group !arh-pr-8"}
            isValid={true}
            onSelect={handleSelectLocation}
            defaultValue={adress?.firstAdress || ""}
            onChange={handleChangeLocation}
          />
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Adresse complémentaire") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="secondAdress"
              placeholder={truncateTextPlaceholder(
                t("Adresse complémentaire"),
                17
              )}
              onBlur={changeAdress}
              defaultValue={adress?.secondAdress || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Numéro d'employé") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="numEmployer"
              placeholder={t("Numéro d'employé")}
              onBlur={(event) =>
                handleEmployeNumberChange(event.target.value, employeId)
              }
              defaultValue={emploi?.numEmployer || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Prénom d'usage") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="firstNameUsed"
              placeholder={t("Prénom d'usage")}
              onBlur={changePersonnalInformation}
              defaultValue={personnalInformation?.firstNameUsed || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Nom d'usage") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="nameUsed"
              placeholder={t("Nom d'usage")}
              onBlur={changePersonnalInformation}
              defaultValue={personnalInformation?.nameUsed || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Autre courriel") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="professionalEmail"
              placeholder={t("Autre courriel")}
              onBlur={changeEmails}
              defaultValue={emails?.professionalEmail || ""}
              invalid={
                emails?.professionalEmail &&
                !REGEX_EMAIL.test(emails?.professionalEmail)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find((clm) => clm.name === "Téléphone professionnel") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="professionalPhone"
              placeholder={t("Téléphone professionnel")}
              onBlur={changeEmails}
              onChange={changeEmails}
              value={emails?.professionalPhone || ""}
              invalid={
                emails?.professionalPhone &&
                !REGEX_PHONE.test(emails?.professionalPhone)
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find(
        (clm) => clm.name === "N de poste (professionnel)"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="professionalPhonePostNumber"
              placeholder={t("N de poste")}
              onBlur={changeEmails}
              defaultValue={emails?.professionalPhonePostNumber || ""}
              invalid={
                emails?.professionalPhonePostNumber &&
                !REGEX_POST_NUMBER.test(emails?.professionalPhonePostNumber)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Nom du 1er contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="contactName"
              placeholder={truncateTextPlaceholder(
                t("Nom du 1er contact d'urgence"),
                23
              )}
              onBlur={changeFirstEmergencyContact}
              defaultValue={firstEmergencyContact?.contactName || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Téléphone du 1er contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="contactPhone"
              placeholder={truncateTextPlaceholder(
                t("Téléphone du 1er contact d'urgence"),
                24
              )}
              onBlur={changeFirstEmergencyContact}
              onChange={changeFirstEmergencyContact}
              value={firstEmergencyContact?.contactPhone || ""}
              invalid={
                firstEmergencyContact?.contactPhone &&
                !REGEX_PHONE.test(firstEmergencyContact?.contactPhone)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Courriel du 1er contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="contactEmail"
              placeholder={truncateTextPlaceholder(
                t("Courriel du 1er contact d'urgence"),
                23
              )}
              onBlur={changeFirstEmergencyContact}
              defaultValue={firstEmergencyContact?.contactEmail || ""}
              invalid={
                firstEmergencyContact?.contactEmail &&
                !REGEX_EMAIL.test(firstEmergencyContact.contactEmail)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Relation avec le 1er contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="employeeRelationship"
              placeholder={truncateTextPlaceholder(
                t("Relation avec le 1er contact d'urgence"),
                28
              )}
              onBlur={changeFirstEmergencyContact}
              defaultValue={firstEmergencyContact?.employeeRelationship || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Nom du 2nd contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="contactName"
              placeholder={truncateTextPlaceholder(
                t("Nom du 2nd contact d'urgence"),
                21
              )}
              onBlur={changeSecondEmergencyContact}
              defaultValue={secondEmergencyContact?.contactName || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Téléphone du 2nd contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="contactPhone"
              placeholder={truncateTextPlaceholder(
                t("Téléphone du 2nd contact d'urgence"),
                24
              )}
              onBlur={changeSecondEmergencyContact}
              onChange={changeSecondEmergencyContact}
              value={secondEmergencyContact?.contactPhone || ""}
              invalid={
                secondEmergencyContact?.contactPhone &&
                !REGEX_PHONE.test(secondEmergencyContact?.contactPhone)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Courriel du 2nd contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="contactEmail"
              placeholder={truncateTextPlaceholder(
                t("Courriel du 2nd contact d'urgence"),
                23
              )}
              onBlur={changeSecondEmergencyContact}
              defaultValue={secondEmergencyContact?.contactEmail || ""}
              invalid={
                secondEmergencyContact?.contactEmail &&
                !REGEX_EMAIL.test(secondEmergencyContact.contactEmail)
              }
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Relation avec le 2nd contact d'urgence"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px]">
            <Input
              name="employeeRelationship"
              placeholder={truncateTextPlaceholder(
                t("Relation avec le 2nd contact d'urgence"),
                28
              )}
              onBlur={changeSecondEmergencyContact}
              defaultValue={secondEmergencyContact?.employeeRelationship || ""}
            />
          </div>
        </td>
      ) : null}

      {selectedColumn.find(
        (clm) => clm.name === "Numéro d’assurance social"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="socialInsuranceNumber"
              placeholder={t("Numéro d’assurance social")}
              onBlur={changeBankingInfo}
              defaultValue={
                BankingAndInsuranceInformation?.socialInsuranceNumber || ""
              }
              invalid={
                BankingAndInsuranceInformation?.socialInsuranceNumber &&
                !/^[0-9]{9}$/.test(
                  BankingAndInsuranceInformation?.socialInsuranceNumber
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find((clm) => clm.name === "Numéro de transit") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="transitNumber"
              placeholder={t("Numéro de transit")}
              onBlur={changeBankingInfo}
              defaultValue={BankingAndInsuranceInformation?.transitNumber || ""}
              invalid={
                BankingAndInsuranceInformation?.transitNumber &&
                !/^[0-9]{5}$/.test(
                  BankingAndInsuranceInformation?.transitNumber
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find((clm) => clm.name === "Numéro d’institution") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="institutionNumber"
              placeholder={t("Numéro d'institution")}
              onBlur={changeBankingInfo}
              defaultValue={
                BankingAndInsuranceInformation?.institutionNumber || ""
              }
              invalid={
                BankingAndInsuranceInformation?.institutionNumber &&
                !/^[0-9]{3}$/.test(
                  BankingAndInsuranceInformation?.institutionNumber
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find((clm) => clm.name === "Numéro de compte") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="accountNumber"
              placeholder={t("Numéro de compte")}
              onBlur={changeBankingInfo}
              defaultValue={BankingAndInsuranceInformation?.accountNumber || ""}
              invalid={
                BankingAndInsuranceInformation?.accountNumber &&
                !(
                  /^[0-9]+$/.test(
                    BankingAndInsuranceInformation?.accountNumber
                  ) &&
                  BankingAndInsuranceInformation?.accountNumber.length >= 7 &&
                  BankingAndInsuranceInformation?.accountNumber.length <= 12
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find((clm) => clm.name === "Numéro de régime") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="planNumber"
              placeholder={t("Numéro de régime")}
              onBlur={changeBankingInfo}
              defaultValue={BankingAndInsuranceInformation?.planNumber || ""}
              invalid={
                BankingAndInsuranceInformation?.planNumber &&
                !(
                  /^[0-9]+$/.test(BankingAndInsuranceInformation?.planNumber) &&
                  BankingAndInsuranceInformation?.planNumber.length >= 7 &&
                  BankingAndInsuranceInformation?.planNumber.length <= 12
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find(
        (clm) => clm.name === "Numéro de certificat d'adhérent"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="memberCertificateNumber"
              placeholder={t("Numéro de certificat d'adhérent")}
              onBlur={changeBankingInfo}
              defaultValue={
                BankingAndInsuranceInformation?.memberCertificateNumber || ""
              }
              invalid={
                BankingAndInsuranceInformation?.memberCertificateNumber &&
                !(
                  /^[0-9]+$/.test(
                    BankingAndInsuranceInformation?.memberCertificateNumber
                  ) &&
                  BankingAndInsuranceInformation?.memberCertificateNumber
                    .length >= 7 &&
                  BankingAndInsuranceInformation?.memberCertificateNumber
                    .length <= 12
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find(
        (clm) => clm.name === "Numéro de plan d'assurance"
      ) ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="insurancePlanNumber"
              placeholder={t("Numéro de plan d'assurance")}
              onBlur={changeBankingInfo}
              defaultValue={
                BankingAndInsuranceInformation?.insurancePlanNumber || ""
              }
              invalid={
                BankingAndInsuranceInformation?.insurancePlanNumber &&
                !(
                  /^[0-9]+$/.test(
                    BankingAndInsuranceInformation?.insurancePlanNumber
                  ) &&
                  BankingAndInsuranceInformation?.insurancePlanNumber.length >=
                    7 &&
                  BankingAndInsuranceInformation?.insurancePlanNumber.length <=
                    12
                )
              }
            />
          </div>
        </td>
      ) : null}
      {selectedColumn.find((clm) => clm.name === "Type de couverture") ? (
        <td className="arh-bg-greyColor arh-p-2 arh-font-poppins arh-text-xs  arh-font-semibold arh-text-darkColor">
          <div className="arh-min-w-[200px] ">
            <Input
              name="typeCover"
              placeholder={t("Type de couverture")}
              onBlur={changeBankingInfo}
              defaultValue={BankingAndInsuranceInformation?.typeCover || ""}
              invalid={
                BankingAndInsuranceInformation?.typeCover &&
                !(
                  /^[0-9]+$/.test(BankingAndInsuranceInformation?.typeCover) &&
                  BankingAndInsuranceInformation?.typeCover.length >= 7 &&
                  BankingAndInsuranceInformation?.typeCover.length <= 12
                )
              }
            />
          </div>
        </td>
      ) : null}
    </>
  );
}

function areEqual(prevProps, nextProps) {
  return (
    prevProps.employe === nextProps.employe &&
    prevProps.emplacementList === nextProps.emplacementList &&
    prevProps.permissionList === nextProps.permissionList &&
    prevProps.postList === nextProps.postList &&
    prevProps.selectedColumn === nextProps.selectedColumn &&
    prevProps.userList === nextProps.userList &&
    prevProps.isChecked === nextProps.isChecked
  );
}

export default React.memo(ItemEmployeList, areEqual);
